import { applyMiddleware, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import { composeWithDevTools } from 'redux-devtools-extension';
import Thunk from 'redux-thunk';
import rootReducer from './reducers';
import { rootPersistConfig } from './persistConfig';

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);
const middlewares = [Thunk];

function configureStore() {
  return createStore(
    persistedReducer,
    composeWithDevTools(applyMiddleware(...middlewares)),
  );
}

export const store = configureStore();
export const persistor = persistStore(store);
